// removed by extract-text-webpack-plugin
module.exports = {"share":"share__share--80b6d5e0","xIcon":"share__xIcon--8e64b348","xIconButton":"share__xIconButton--a7b735b8","shareCenter":"share__shareCenter--95bb84a2","iconContainer":"share__iconContainer--39a8afb9","icons":"share__icons--6167bbdb","input":"share__input--00374b8e","copyLink":"share__copyLink--24cb2a37","loadingAnimation":"share__loadingAnimation--a3c677b3","animate":"share__animate--6b69088d"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/share.scss
// module id = 57
// module chunks = 0